import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api.ts';
import { useAuth } from '../../auth/AuthContext.tsx';
import { TopBar } from '../../components/TopBar.tsx';
import { BottomNav } from '../../components/BottomNav.tsx';
import { AvatarEditor } from '../../components/AvatarEditor.tsx';
import type { ExtraProfile } from '../../types.ts';

export function ExtraProfileSelf() {
  const { user, logout } = useAuth();
  const [profile, setProfile] = useState<ExtraProfile | null>(null);

  useEffect(() => {
    api.get<{ extra: ExtraProfile }>('/extras/me').then((res) => setProfile(res.extra));
  }, []);

  return (
    <div className="app-shell">
      <TopBar title="Mon profil" />
      <div className="screen-content">
        <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'center', textAlign: 'center' }}>
          <div style={{ fontSize: 18, fontWeight: 800 }}>{user?.firstName} {user?.lastName}</div>
          <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{user?.email}</div>
        </div>

        <AvatarEditor name={`${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim()} />

        {profile && (
          <div className="stat-row">
            <div className="card stat-card">
              <div className="stat-value">{profile.reputation_score ? profile.reputation_score.toFixed(1) : '—'}</div>
              <div className="stat-label">Note moyenne</div>
            </div>
            <div className="card stat-card">
              <div className="stat-value">{profile.missions_completed}</div>
              <div className="stat-label">Missions</div>
            </div>
          </div>
        )}

        <Link to="/extra/avis" className="card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div style={{ fontWeight: 800, marginBottom: 4 }}>Mes avis</div>
          <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Notes par critère, tags reçus et signalements éventuels, avec la possibilité de répondre.</div>
        </Link>

        <div className="card">
          <div style={{ fontWeight: 800, marginBottom: 8 }}>Mon profil professionnel</div>
          <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 12 }}>
            Postes, compétences, logiciels, langues, équipement, disponibilités : les établissements s'en servent pour vous trouver et vous classer.
          </div>
          <Link to="/extra/profil-pro" className="btn btn-secondary" style={{ textDecoration: 'none', textAlign: 'center' }}>Compléter mon profil</Link>
        </div>

        <Link to="/extra/activite/verifications" className="card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div style={{ fontWeight: 800, marginBottom: 4 }}>Mes expériences et références</div>
          <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Déclarez une expérience avec un référent (obligatoire pour candidater) : il note vos compétences par e-mail ou SMS.</div>
        </Link>

        <Link to="/extra/paiements" className="card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div style={{ fontWeight: 800, marginBottom: 4 }}>Recevoir mes paiements</div>
          <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Vérification de votre identité et de votre IBAN, une seule fois, sans compte Stripe. Les virements partent ensuite automatiquement.</div>
        </Link>

        <button className="btn btn-danger-outline" onClick={() => logout()}>Se déconnecter</button>
      </div>
      <BottomNav />
    </div>
  );
}
